export interface PromotionItemType {
  Id: number;
  Description: string;
  ButtonText: string;
  ButtonUrl: string;
  EndDate: string;
  ImageUrl: string;
  Title: string;
  StartDate: string;
  ShortDescription: string;
  SequenceNumber: number;
}

export type PromotionListType = PromotionItemType[];

export class PromotionItemModel {
  Id: number;
  Description: string;
  ButtonText: string;
  ButtonUrl: string;
  EndDate: string;
  ImageUrl: string;
  Title: string;
  StartDate: string;
  ShortDescription: string;
  SequenceNumber: number;

  constructor(promotionItem: PromotionItemType) {
    this.Id = promotionItem.Id;
    this.Description = promotionItem.Description;
    this.ButtonText = promotionItem.ButtonText;
    this.ButtonUrl = promotionItem.ButtonUrl;
    this.EndDate = promotionItem.EndDate;
    this.ImageUrl = promotionItem.ImageUrl;
    this.Title = promotionItem.Title;
    this.StartDate = promotionItem.StartDate;
    this.ShortDescription = promotionItem.ShortDescription;
    this.SequenceNumber = promotionItem.SequenceNumber;
  }
}

export class PromotionListModel {
  public promotionList: PromotionListType;
  constructor(promotionList: PromotionListType) {
    if (Array.isArray(promotionList) && promotionList.length > 0) {
      this.promotionList = promotionList.map((promotionItem: PromotionItemType) => new PromotionItemModel(promotionItem));
    } else {
      this.promotionList = [];
    }
  }
}
